import moment from "moment";

class employees {
  constructor(grupoId, empId, from, to, defaultGrp, lastName, name, file) {
    this.grupoId = grupoId;
    this.empId = empId;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? "" : moment.utc(to).format("DD-MM-YYYY");
    this.defaultGrp = defaultGrp == "S" ? "✔️" : "";
    this.name = name;
    this.lastName = lastName;
    this.file = file;
    this.fullName = name + " " + lastName;
  }

  static fromJson({
    grupoId,
    empId,
    fecDesde,
    fecHasta,
    defaultGrp,
    apellido,
    nombres,
    legajo,
  }) {
    return new employees(
      grupoId,
      empId,
      fecDesde,
      fecHasta,
      defaultGrp,
      apellido,
      nombres,
      legajo,
    );
  }
}

export default employees;
